import React, { useState, useEffect } from "react"
import Collapsible from "react-collapsible"
import { usePageVisibility } from "react-page-visibility"

import Plus from "@assets/icons/plus.inline.svg"
import Minus from "@assets/icons/minus.inline.svg"
import { ControlledCarousel } from "@components/common/carousel/ControlledCarousel"

import { Props } from "./AccordionCarousel.interface"
import * as s from "./AccordionCarousel.module.scss"

export const AccordionCarousel = ({ data }: Props) => {
  const slides = data.slides || []
  const [activeSlide, setActiveSlide] = useState(0)
  const [activeIndex, setActiveIndex] = useState(0)
  const [selected, setSelected] = useState(false)
  const isVisible = usePageVisibility()

  /*eslint-disable*/
  useEffect(() => {
    if (!selected && isVisible) {
      if (activeIndex === -1) {
        setActiveIndex(old => {
          return 0
        })
      }
      const timer = setTimeout(() => {
        if (activeIndex >= slides.length - 1) {
          setActiveIndex(old => {
            return 0
          })
        } else {
          setActiveIndex(old => {
            return old + 1
          })
        }
      }, 15500)
      return () => clearTimeout(timer)
    }
    return
  }, [activeIndex, selected, isVisible])

  function handleSelect() {
    setSelected(true)
  }

  function handleChange(index) {
    setActiveIndex(old => {
      return index
    })
    setActiveSlide(old => {
      return index
    })
  }
  /*eslint-enable*/

  if (!slides) {
    return <></>
  }

  function close() {
    setActiveIndex(prev => {
      if (prev === activeIndex && prev !== 0) {
        return -1
      }
    })
  }
  return (
    <div className={s.accordianCarousel}>
      <div className={s.accordianCarousel__accordian}>
        {slides.map((slide, i) => {
          return (
            <Collapsible
              key={i}
              id="collapsible"
              transitionTime={500}
              transitionCloseTime={500}
              onOpening={() => {
                handleChange(i)
              }}
              onClosing={() => close()}
              className={`${s.accordianCarousel__accordian___trigger} `}
              openedClassName={s.accordianCarousel__accordian___triggerOpen}
              open={activeIndex === i}
              triggerWhenOpen={
                <div
                  onClick={() => {
                    handleSelect()
                  }}
                  className={s.accordianCarousel__accordian___triggerContainer}
                >
                  <h5 className={s.accordianCarousel__accordian___triggerTitle}>
                    {slide.title}
                  </h5>
                  <Minus
                    className={s.accordianCarousel__accordian___triggerIcon}
                  />
                </div>
              }
              trigger={
                <div
                  className={s.accordianCarousel__accordian___triggerContainer}
                  onClick={() => {
                    handleSelect()
                  }}
                >
                  <h5 className={s.accordianCarousel__accordian___triggerTitle}>
                    {slide.title}
                  </h5>
                  <Plus
                    className={s.accordianCarousel__accordian___triggerIcon}
                  />
                </div>
              }
            >
              <div className={s.accordianCarousel__accordian___triggerBlurb}>
                <p dangerouslySetInnerHTML={{ __html: slide.blurb }} />
              </div>
            </Collapsible>
          )
        })}
      </div>
      <div className={s.accordianCarousel__carousel}>
        <ControlledCarousel
          selectedSlide={activeSlide}
          isPaused={selected}
          onChange={handleChange}
          styleType="BRAND"
          data={{ slides }}
        />
      </div>
    </div>
  )
}
